export default {"src":"/_next/static/media/turtle.a7142df0.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};